export default __webpack_public_path__ + "static/media/photo3-lqMAX.55a972ca.jpg";